import {CommonModule} from '@angular/common'
import {NgModule} from '@angular/core'
import {FlexLayoutModule} from '@angular/flex-layout'
import {ReactiveFormsModule} from '@angular/forms'
import {MatAutocompleteModule} from '@angular/material/autocomplete'
import {MatButtonModule} from '@angular/material/button'
import {MatDatepickerModule} from '@angular/material/datepicker'
import { MatDividerModule } from '@angular/material/divider'
import {MatIconModule} from '@angular/material/icon'
import {MatInputModule} from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'
import {WishlistsRoutingModule} from './wishlists-routing.module'
import {WishlistsComponent} from './wishlists/wishlists'
import {SharedFlokModule} from "../../module/shared-flok/shared-flok.module";
import {SharedMemberModule} from "../../module/shared-member/shared-member.module";
import {WishlistComponent} from "./wishlists/wishlist/wishlist";
import {FormatPipeModule, ParseIsoPipeModule} from "ngx-date-fns";
import {MatDialogModule} from "@angular/material/dialog";
import {CreateWishlistComponent} from "./wishlists/create-wishlist/create-wishlist";
import {UpdateWishlistComponent} from "./wishlists/update-wishlist/update-wishlist";
import {MatSelectModule} from "@angular/material/select";
import {AddToWishlistComponent} from "./wishlists/add-to-wishlist/add-to-wishlist";
import {SelectWishlistComponent} from "./wishlists/select-wishlist/select-wishlist";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {
    BusinessCustomerAutocompleteComponent
} from "../../module/shared-member/organism/business-customer-autocomplete/business-customer-autocomplete";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTooltipModule} from "@angular/material/tooltip";

@NgModule({
    declarations: [
        AddToWishlistComponent,
        CreateWishlistComponent,
        SelectWishlistComponent,
        WishlistComponent,
        WishlistsComponent,
        UpdateWishlistComponent
    ],
    exports: [
        WishlistsComponent,
        AddToWishlistComponent,
        BusinessCustomerAutocompleteComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDatepickerModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        WishlistsRoutingModule,
        MatAutocompleteModule,
        SharedFlokModule,
        SharedMemberModule,
        FormatPipeModule,
        ParseIsoPipeModule,
        MatDialogModule,
        MatMenuModule,
        MatSelectModule,
        NgxIntlTelInputModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatDividerModule
    ]
})
export class WishlistsModule {}
